<template>
    <div>
        <div v-if="!model.isMultiDropdown">
            <kendo-dropdownlist
                v-if="!loading"
                v-model="selectedId"
                :data-source="items"
                :data-text-field="'text'"
                :data-value-field="'id'"
                :optionLabel="$t('choose')"
                :filter="filterPattern"
                :disabled="details || model.isReadOnly"
                :height="height"
                :footer-template="nomDropdownSettings.showFooterTemplate ? footerTemplate : ''"
                style="width: 100%;"
            ></kendo-dropdownlist>

            <DropdownSettings
                v-if="loaded"
                :filterPattern.sync="filterPattern"
                :show.sync="showSettings"
            ></DropdownSettings>
        </div>
        <div v-if="model.isMultiDropdown">
            <static-register-multi-select
                v-model="model.fieldValue.textValue"
                :details="details"
                :model="model"
                :field-name="isEnVersion ? model.labelEn : model.label"
                :height="height"
            ></static-register-multi-select>
        </div>
        <span
            class="text-danger col-12"
            v-if="errors.has('dropdown' + _uid)"
        >{{ errors.first('dropdown' + _uid) }}</span>
    </div>
</template>

<script>
import Vue from "vue";
import StaticRegisterMultiSelect from "./StaticRegisterMultiSelect";
import FooterTemplate from "../../components/grid/NomenclatureDropdownFooterTemplate";
import DropdownSettings from "../../components/common/DropdownSettings";
import { mapGetters } from "vuex";
import { RegisterEventBus } from '@/buses/register-bus.js';

export default {
    inject: ["$validator"],
    props: {
        value: [String, Number],
        model: Object,
        details: {
            type: Boolean,
            default: false,
        },
        height: {
            type: Number,
            default: 400, // 200 - Default value for Kendo DropdownList
        }
    },
    components: {
        StaticRegisterMultiSelect,
        DropdownSettings,
    },
    data() {
        return {
            selectedId: this.value || "",
            items: [],
            loaded: false,
            loading: true,
            multiSelectValue: "",
            showSettings: false,
            filterPattern: "",
        };
    },
    methods: {
        loadDropdownData() {
            this.loading = true;
            this.$http
                .get(
                    `/api/Dropdown/GetStaticRegisterItems?registerId=${this.model.dropdownId}&selected=${this.value}
                    &updateTime=${this.model.fieldValue.updateTime ? new Date(this.model.fieldValue.updateTime).toISOString() : new Date().toISOString()}`
                )
                .then((result) => {
                    this.items = result.data;
                    this.populateStringValueById(this.selectedId);
                })
                .catch((error) => {
                    this.$vs.notify({
                        title: this.$t(
                            "request.response.status." +
                                this.$helpers.errorStatusCode(error)
                        ),
                        text: this.$helpers.errorText(error),
                        color: "warning",
                        time: this.$store.getters.notificationDuration,
                    });
                })
                .then(() => {
                    this.loaded = true;
                    this.loading = false;
                });
        },
        populateStringValueById(id) {
            // eslint-disable-next-line eqeqeq
            const val = this.items.filter((item) => item.id == id);
            if (val && val.length > 0) {
                this.model.fieldValue.stringValue = val[0].text;
            }
        },
        footerTemplate: function (e) {
            return {
                template: Vue.component(FooterTemplate.name, FooterTemplate),
                templateArgs: {
                    ...e,
                    btns: [
                        {
                            name: "staticRegisterDropdownSettings",
                            text: this.$t("buttons.settings.btnText"),
                            tooltip: this.$t("buttons.settings.btnText"),
                            class: "btn btn-secondary",
                            icon: "fas fa-cog",
                            show: this.nomDropdownSettings.showSettings,
                            clickHandler: () => {
                                this.showSettings = true;
                            },
                        },
                    ],
                },
            };
        },
    },
    watch: {
        selectedId: function (newVal, oldVal) {
            this.$emit("input", newVal);
            RegisterEventBus.$emit('dynamic-field-change', newVal, oldVal, this.model);
            this.model.fieldValue.intValue = newVal;
            // this.populateStringValueById(newVal);
        },
        value: function (newVal, oldVal) {
            if (this.model.isMultiDropdown) {
                this.multiSelectValue = newVal;
                this.model.fieldValue.textValue = newVal;
            } else {
                this.selectedId = newVal;
            }
        },
        multiSelectValue(newVal, oldVal) {
            this.model.fieldValue.textValue = newVal;
        },
    },
    computed: {
        ...mapGetters(['isEnVersion', 'nomDropdownSettings']),
    },
    mounted() {
        if (!this.model.isMultiDropdown) {
            this.filterPattern = this.nomDropdownSettings.defaultFilterPattern;
            this.loadDropdownData();
        } else {
            this.loading = false;
        }
    },
};
</script>
